import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CheckoutOrderSummaryService {
  constructor(
    private httpClient: HttpClient,
    private occService: OccEndpointsService
  ) {}
  reorder(requestBody: any, userData: any, cartId: any): Observable<any> {
    return this.httpClient.post<any>(
      this.occService.buildUrl(
        `/users/${userData.uid}/carts/${cartId}/reorder`
      ),
      requestBody
    );
  }
}
